import { get, appendJs } from 'mulan-lib'
import { processRequest} from "../../util/common";
import config from '@/config'
import wxHideMenuItem, { MENU_ITEM } from './wx-hide-menu-item'
import wxJsApiList    from './wx-js-api-list'
const {signApi,appid} = config;

let wx = window.wx

const isIOS = () => /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)

const handleHideMenuItems = (wx, { isHideAppMessage = false, isHideTimeline = false }) => {
  const menuList = wxHideMenuItem
  if (isHideTimeline) {
    menuList.push(MENU_ITEM.TIMELINE)
  }
  if (isHideAppMessage) {
    menuList.push(MENU_ITEM.APP_MESSAGE)
  }
  wx.hideMenuItems({
    menuList
  })
}

const handleSetShare = (wx, { shooseInfo }) => {
  const { count = 1, sizeType = ['original', 'compressed'], sourceType = ['album', 'camera'], success = () => {}, cancel = () => {} } = shooseInfo
  // wx.onMenuShareTimeline({
  //   title: timelineTitle || title,
  //   link,
  //   imgUrl,
  //   success: () => {
  //     // console.log('分享朋友圈成功')
  //     const _hmt = window._hmt
  //     if (_hmt) _hmt.push(['_trackEvent', 'wx', 'share_timeline'])
  //     success()
  //   },
  //   cancel
  // })
  wx.chooseImage({
    count, // 默认9
    sizeType, // 可以指定是原图还是压缩图，默认二者都有
    sourceType, // 可以指定来源是相册还是相机，默认二者都有
    success
  });

}
const getSign = (params = {}, cb) => {
  const { debug = false } = params
  processRequest(
    get(signApi, {
      url: isIOS() ? window.entryUrl : window.location.href.split('#')[0],
      appId: appid
    }),
    data => {
      // const { config } = data
      const { appid, timestamp, noncestr, sign } = data
      wx.config({
        debug: false,//debug == 1,
        appId: appid,
        timestamp,
        nonceStr: noncestr,
        signature: sign,
        jsApiList: wxJsApiList
      })
      wx.ready(() => {
        handleHideMenuItems(wx, params)
        if (params && params.shooseInfo) handleSetShare(wx, params)
        cb && cb(wx)
      })
    }
  )
}



const init = (params, cb) => {
  if (!wx) {
    appendJs('https://res.wx.qq.com/open/js/jweixin-1.2.0.js', () => {
      wx = window.wx
      getSign(params, cb)
    })
  } else {
    getSign(params, cb)
  }

}

export default init


if (!window.entryUrl) window.entryUrl = window.location.href.split('#')[0]
